import { defineMessages } from 'react-intl';

export const accountSelectionForAnalysisMessages = defineMessages({
  notificationSuccess: {
    id: 'widgets.bank_statements.account_selection_for_analysis.notification_success',
    defaultMessage: 'The list of accounts has been successfully modified. The analysis has been updated.',
    description: 'Text of account selection for analysis success notification',
  },
  notificationError: {
    id: 'widgets.bank_statements.account_selection_for_analysis.notification_error',
    defaultMessage: 'The list of accounts could not be modified.',
    description: 'Text of account selection for analysis error notification',
  },
  notificationCheckingError: {
    id: 'widgets.bank_statements.account_selection_for_analysis.notification_checking_error',
    defaultMessage:
      'The list of accounts could not be modified. You need at least one checking account with more than 20 transactions.',
    description: 'Text of account selection for analysis error notification because there is not a checking account',
  },
});
